import type { ExpenseStatus, FuelType } from '@rfleet/shared';

export interface ExpenseCategory {
  id: string;
  kind: string;
  nameAr: string;
  nameEn: string;
  isFuel: boolean;
}

export interface FuelLog {
  expenseId: string;
  vehicleId: string;
  liters: string | number;
  pricePerLiter: string | number;
  fuelType: FuelType;
  odometerKm: string | number | null;
  isFullTank: boolean;
  stationPlaceId: string | null;
  kmSincePrev: string | number | null;
  lPer100Km: string | number | null;
  egpPerKm: string | number | null;
}

export interface ExpenseRow {
  id: string;
  number: string;
  status: ExpenseStatus;
  amountEgp: string | number;
  occurredAt: string;
  lat: number | null;
  lon: number | null;
  placeId: string | null;
  locationText: string | null;
  receiptFileId: string | null;
  notes: string | null;
  isRebillable: boolean;
  rejectReason: string | null;
  reviewedAt: string | null;
  createdAt: string;
  category: ExpenseCategory;
  vehicle: { id: string; plateAr: string; name: string | null } | null;
  driver: { id: string; fullName: string } | null;
  trip: { id: string; number: string } | null;
  fuelLog: FuelLog | null;
}

export interface ExpenseDetail extends ExpenseRow {
  placeName: string | null;
  submittedByName: string | null;
  reviewedByName: string | null;
  receiptUrl: string | null;
}

export interface ExpenseAnalytics {
  totalEgp: number;
  count: number;
  fuelEgp: number;
  pendingCount: number;
  pendingEgp: number;
  byCategory: { id: string; nameAr: string; nameEn: string; kind: string; total: number; count: number }[];
  byVehicle: { id: string; plateAr: string; total: number; count: number }[];
  byDriver: { id: string; fullName: string; total: number; count: number }[];
  byMonth: { month: string; total: number; fuel: number }[];
}

export interface FuelConsumption {
  items: {
    expenseId: string;
    number: string;
    occurredAt: string;
    vehicle: { id: string; plateAr: string; name: string | null; fuelType: FuelType | null };
    driver: { id: string; fullName: string } | null;
    liters: number;
    pricePerLiter: number;
    amountEgp: number;
    fuelType: FuelType;
    odometerKm: number | null;
    isFullTank: boolean;
    kmSincePrev: number | null;
    lPer100Km: number | null;
    egpPerKm: number | null;
  }[];
  summary: { fills: number; liters: number; amountEgp: number; km: number; avgLPer100Km: number | null; avgEgpPerKm: number | null };
}

export const expenseTone = (s: ExpenseStatus): 'warning' | 'success' | 'danger' => (s === 'PENDING' ? 'warning' : s === 'APPROVED' ? 'success' : 'danger');

export const catName = (c: { nameAr: string; nameEn: string }, lang: string) => (lang === 'en' ? c.nameEn : c.nameAr);
